import type { BatchTransitionContextValue } from "./batch-transition.type";

import { createContext, useContext } from "react";

export const config = {
  contextName: "BatchTransitionContext",
  providerName: "BatchTransitionProvider",
};

export const BatchTransitionContext =
  createContext<BatchTransitionContextValue | null>(null);

export const useBatchTransitionContext = () => {
  const contextValue = useContext(BatchTransitionContext);

  if (!contextValue) {
    throw new Error(
      `${config.contextName} must be used within a ${config.providerName}`
    );
  }

  return contextValue;
};
